import { gql } from '@apollo/client';

export const GET_REPORT_CONFIGS = gql`
  query ReportGenConfigs($portfolioId: String!, $skip: Int, $take: Int) {
    reportGenConfigs(portfolioId: $portfolioId, skip: $skip, take: $take) {
      id
      portfolioId
      name
      recipient
      columns {
        id
        label
        property
        constant
        createdDt
        createdBy
      }
      createdDt
      createdBy
      modifiedDt
      modifiedBy
      isDeleted
    }
  }
`;
